import React from 'react';
import { useLottie } from 'lottie-react';
import processing from './lottie-120435-document-error.json';

const ProcessingOrder = ({ color = '#96c11f' }) => {
  // Function to convert hex color to rgba array
  const hexToRgbaArray = (hex) => {
    // Remove # if present
    const cleanHex = hex.replace('#', '');

    // Parse hex values
    const r = parseInt(cleanHex.substr(0, 2), 16) / 255;
    const g = parseInt(cleanHex.substr(2, 2), 16) / 255;
    const b = parseInt(cleanHex.substr(4, 2), 16) / 255;
    const a = 1; // Full opacity

    return [r, g, b, a];
  };

  // Function to recursively change colors in the animation data
  const changeAnimationColor = (animationData, newColor) => {
    const modifiedData = JSON.parse(JSON.stringify(animationData));
    const rgbaColor = hexToRgbaArray(newColor);

    const changeColorRecursive = (obj) => {
      if (Array.isArray(obj)) {
        obj.forEach(changeColorRecursive);
      } else if (obj && typeof obj === 'object') {
        // Look for stroke and fill color properties
        if (obj.c && Array.isArray(obj.c.k) && obj.c.k.length === 4) {
          obj.c.k = [...rgbaColor];
        }

        Object.values(obj).forEach(changeColorRecursive);
      }
    };

    changeColorRecursive(modifiedData);
    return modifiedData;
  };

  const modifiedAnimationData = changeAnimationColor(processing, color);

  const options = {
    animationData: modifiedAnimationData,
    loop: true,
  };

  const { View } = useLottie(options);

  return <>{View}</>;
};

export default ProcessingOrder;
